<template>
    <transition name="fade">
        <div class="patient-coaching-summary-goals">

            <div class="float-right"
                 v-if="showEditLinks">
                <my-goals-edit-modal :goals="goals">
                </my-goals-edit-modal>
            </div>

            <b-row v-for="(g, index) in goals" :key="index">
                <b-col cols="3" class="text-center">
                    <label>{{ g.timeframe }}</label>
                </b-col>
                <b-col cols="1" class="pb-2"
                       v-if="showEditLinks">
                    <my-goals-edit-modal :goals="goals"
                                         :goal="g"
                                         :index="index">
                    </my-goals-edit-modal>
                </b-col>
                <b-col :cols="showEditLinks ? 7 : 8" class="pb-2">
                    {{ g.goal }}
                </b-col>
            </b-row>

        </div>
    </transition>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'PatientCoachingSummaryGoals',
    props: {
        showEditLinks: {type: Boolean, default: false }
    },
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        goals() {
            return this.participant.wellness_plan ? this.participant.wellness_plan.goals : []
        },
    }
})
</script>

